// eslint-disable-next-line import/no-anonymous-default-export
export default {
  DEFAULT_EXCHANGE_FACTOR: 0,
}